<script>
export default {
  props: {
    visible: Boolean,
    autoscrollEvent: Boolean,
    autoscrollTolerance: {
      type: Number,
      default: 10
    },
    resetScroll: [String, Object, Array],
  },
  methods: {
    async scrollHandler() {
      if (
        this.$refs.scrollStuff.clientHeight +
          this.$refs.scrollStuff.scrollTop >=
        this.$refs.scrollStuff.scrollHeight - this.autoscrollTolerance
      ) {
        this.$emit("autoload", true);
      } else {
        this.$emit("autoload", false);
      }
    },
  },
  watch: {
    resetScroll() {
      this.$refs.scrollStuff.scrollTop = 0;
    },
  },
  mounted() {
    if (this.autoscrollEvent && this.$refs.scrollStuff) {
      this.$refs.scrollStuff.addEventListener("scroll", this.scrollHandler);
    }
  },
  destroyed() {
    if (this.autoscrollEvent && this.$refs.scrollStuff) {
      this.$refs.scrollStuff.removeEventListener("scroll", this.scrollHandler);
    }
  },
};
</script>

<template>
  <div class="f-sexy-scroll" :class="{ visible }" ref="scrollStuff">
    <div class="f-sexy-scroll-inner" ref="innerScrollStuff">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss">
.f-sexy-scroll {
  overflow: auto;

  .f-sexy-scroll-inner {
  }

  /* width */
  &::-webkit-scrollbar {
    width: 16px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-track:hover {
    border-radius: 2px;
    background: #f3f3f3;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: rgba(22, 22, 21, 0.1);
    border-radius: 8px;
    border: solid transparent 4px;
    background-clip: content-box;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #dddddd;
    border-radius: 8px;
    border: solid transparent 4px;
    background-clip: content-box;
  }

  &::-webkit-scrollbar-corner {
    background: transparent;
  }

  &.visible {
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background: #dddddd;
      border-radius: 8px;
      border: solid transparent 4px;
      background-clip: content-box;
    }
  }

  &.dark {
    /* Track */
    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-track:hover {
      border-radius: 2px;
      background: hwb(0 90% 10% / 10%);
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: hwb(0 92% 8% / 0.1);
      border-radius: 8px;
      border: solid transparent 4px;
      background-clip: content-box;
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: hwb(0 100% 0% / 0.1);
      border-radius: 8px;
      border: solid transparent 4px;
      background-clip: content-box;
    }

    &::-webkit-scrollbar-corner {
      background: transparent;
    }

    &.visible {
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      &::-webkit-scrollbar-thumb {
        background: hwb(0 13% 87%);
        border-radius: 8px;
        border: solid transparent 4px;
        background-clip: content-box;
      }
    }
  }
}
.dark-mode {
  .f-sexy-scroll {
    &::-webkit-scrollbar-track:hover {
      background: var(--white-a5);
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: var(--white-a25);
      border-radius: 8px;
      border: solid transparent 4px;
      background-clip: content-box;
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: var(--white-a50);
      border-radius: 8px;
      border: solid transparent 4px;
      background-clip: content-box;
    }
  }
}
</style>